/* Shto tier buy box (sections/shto-product-buy-tiers.liquid): tiers, One-time / Subscribe, quantity, photos. Runs once per section.
   Works like the live liposomal buy box (assets/theme-scripts.js, .product-variant-option / .product-subscription-option):
   - a tier is the variant (radio name="id"); choosing it shows its prices and its own plan dropdown;
   - only the chosen variant's dropdown carries name="selling_plan", and only while Subscribe is chosen;
   - choosing a plan in the dropdown chooses Subscribe. The page's address follows the variant (?variant=), as live. */
(function () {
  if (window.shtoProductBuyTiersJS) return;
  window.shtoProductBuyTiersJS = true;

  // Smooth scroll for the rating pill (to the reviews), landing below the theme's fixed header, as shto-product-buy.js.
  function headerBottom() {
    var h = document.getElementById('header') || document.querySelector('header');
    if (!h) return 0;
    var pos = getComputedStyle(h).position;
    if (pos !== 'fixed' && pos !== 'sticky') return 0;
    return Math.max(0, h.getBoundingClientRect().bottom);
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-shto-pbt-scroll]');
    if (!link) return;
    var hash = link.getAttribute('href') || '';
    if (hash.charAt(0) !== '#' || hash.length < 2) return;
    var target = document.getElementById(decodeURIComponent(hash.slice(1)));
    if (!target) return;
    event.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Going down the theme hides its header, so the reviews land at the top; going up they land under the header.
    var down = target.getBoundingClientRect().top >= 0;
    var tries = 0;
    function offBy() { return target.getBoundingClientRect().top - (down ? 0 : headerBottom()); }
    function go() {
      window.scrollTo({ top: Math.max(0, offBy() + window.pageYOffset), behavior: reduce || tries > 0 ? 'auto' : 'smooth' });
    }
    // Photos and widgets above the reviews can still be loading while the page scrolls, which moves the reviews down:
    // once the scroll ends, land on them again (at most three times), then stop listening.
    function settle() {
      tries += 1;
      if (tries > 3 || Math.abs(offBy()) < 2) { window.removeEventListener('scrollend', settle); return; }
      go();
    }
    window.removeEventListener('scrollend', window.shtoPBTSettle || function () {});
    window.shtoPBTSettle = settle;
    if ('onscrollend' in window) window.addEventListener('scrollend', settle);
    else setTimeout(settle, 1200);
    go();
  });

  // Promix's own content sections (product-science-accordion etc.) have "Add To Bag" buttons [data-product-content-cta].
  // Their assets/product-content-sections.js clicks #singleProduct's add to cart, which our pages don't have: then this
  // clicks our buy box's button instead, adding the current selection, as live.
  document.addEventListener('click', function (event) {
    var cta = event.target.closest && event.target.closest('[data-product-content-cta]');
    if (!cta || document.querySelector('#singleProduct')) return;
    var button = document.querySelector('[data-shto-pbt] .addToCartButton.add_to_cart:not([disabled])');
    if (button) button.click();
  });

  function init(root) {
    if (root.shtoPBT) return;
    root.shtoPBT = true;
    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var tiers = qa('[data-shto-pbt-tier]');
    var modes = qa('[data-shto-pbt-mode]');
    var plans = qa('[data-shto-pbt-plan]');
    var atc = q('[data-shto-pbt-atc]');

    function chosenTier() { return tiers.filter(function (t) { return t.checked; })[0] || tiers[0]; }
    function chosenMode() { var m = modes.filter(function (i) { return i.checked; })[0]; return m ? m.value : 'onetime'; }
    function setText(sel, text) { if (text == null) return; qa(sel).forEach(function (el) { el.textContent = text; }); }

    function apply(mode) {
      var tier = chosenTier();
      if (!tier) return;
      var hasPlan = tier.hasAttribute('data-sub');
      var onceOk = tier.getAttribute('data-requires-plan') !== 'true';
      if (!hasPlan) mode = 'onetime';
      else if (!onceOk) mode = 'subscribe';
      modes.forEach(function (i) {
        i.checked = i.value === mode;
        if (i.value === 'onetime') i.disabled = !onceOk;
      });
      root.setAttribute('data-mode', mode);
      qa('[data-shto-pbt-card]').forEach(function (card) {
        var kind = card.getAttribute('data-shto-pbt-card');
        card.setAttribute('data-selected', kind === mode ? 'true' : 'false');
        card.hidden = (kind === 'subscribe' && !hasPlan) || (kind === 'onetime' && !onceOk);
      });
      tiers.forEach(function (t) {
        var row = t.closest('[data-shto-pbt-tier-row]');
        if (row) row.setAttribute('data-selected', t === tier ? 'true' : 'false');
      });
      plans.forEach(function (select) {
        var mine = select.getAttribute('data-shto-pbt-plan') === tier.value;
        select.hidden = !mine;
        if (mine && mode === 'subscribe') select.setAttribute('name', 'selling_plan');
        else select.removeAttribute('name');
      });
      setText('[data-shto-pbt-once]', tier.getAttribute('data-once'));
      if (hasPlan) {
        setText('[data-shto-pbt-sub]', tier.getAttribute('data-sub'));
        setText('[data-shto-pbt-percent]', tier.getAttribute('data-percent'));
      }
      if (atc) {
        atc.disabled = tier.disabled;
        var label = atc.querySelector('[data-shto="add-to-cart.text"]');
        if (label) label.textContent = tier.disabled ? atc.getAttribute('data-sold-out') : atc.getAttribute('data-label');
      }
    }

    tiers.forEach(function (t) {
      t.addEventListener('change', function () {
        if (!t.checked) return;
        apply(chosenMode());
        // The address follows the variant, like the live product page, keeping the rest of the query (preview links).
        // Only on a product page: on a landing page (/pages/...) the address stays as it is.
        if (root.getAttribute('data-shto-variant-url') !== 'on') return;
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', t.value);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) {}
      });
    });
    modes.forEach(function (i) { i.addEventListener('change', function () { if (i.checked) apply(i.value); }); });
    plans.forEach(function (select) {
      select.addEventListener('change', function () { apply('subscribe'); });
      select.addEventListener('focus', function () { if (chosenMode() !== 'subscribe') apply('subscribe'); });
    });
    apply(chosenMode());

    // Quantity, 1 to 100 like the theme's field.
    var qty = q('[data-shto-pbt-qty-input]');
    function setQty(n) {
      n = parseInt(n, 10);
      if (isNaN(n)) n = 1;
      qty.value = Math.min(100, Math.max(1, n));
    }
    if (qty) {
      qa('[data-shto-pbt-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () { setQty((parseInt(qty.value, 10) || 1) + Number(btn.getAttribute('data-shto-pbt-qty'))); });
      });
      qty.addEventListener('change', function () { setQty(qty.value); });
    }

    // Photos: thumbnails move the main photo; swiping the photo marks its thumbnail.
    var track = q('[data-shto-pbt-track]');
    var slides = qa('[data-shto-pbt-slide]');
    var thumbs = qa('[data-shto-pbt-thumb]');
    var row = q('[data-shto-pbt-thumbs]');
    var current = 0;
    function mark(i) {
      current = i;
      thumbs.forEach(function (t, j) { if (j === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      var t = thumbs[i];
      if (row && t && row.scrollWidth > row.clientWidth + 1) {
        var left = t.offsetLeft - thumbs[0].offsetLeft, right = left + t.offsetWidth;
        if (left < row.scrollLeft) row.scrollTo({ left: left, behavior: 'smooth' });
        else if (right > row.scrollLeft + row.clientWidth) row.scrollTo({ left: right - row.clientWidth, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        if (!track || !slides[i]) return;
        mark(i);
        track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      });
    });
    if (track) {
      track.addEventListener('scroll', function () {
        if (!slides.length) return;
        var w = slides[0].offsetWidth || 1;
        var i = Math.min(slides.length - 1, Math.round(track.scrollLeft / w));
        if (i !== current) mark(i);
      }, { passive: true });
    }
  }
  function initAll() { document.querySelectorAll('[data-shto-pbt]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
